import { useCallback, useEffect, useState } from "react";

import { getGeoLocation } from "services";

import { changeLanguage, getLanguageCodeFromCountryCode, getLanguageFromLocalStorage, setLanguageInLocalStorage, useUserContext } from "utils";

export const useLanguage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserContext();

  const handleLanguageChange = (localeCode: string) => {
    const newLanguageCode = getLanguageCodeFromCountryCode(localeCode);
    changeLanguage(newLanguageCode, null).finally(() => {
      setIsLoading(false);
    });
  };

  const getLanguageBasedOnLocation = useCallback(() => {
    if (getLanguageFromLocalStorage()) {
      setLanguageInLocalStorage().finally(() => {
        setIsLoading(false);
      });
      return;
    }
    getGeoLocation().then((data) => {
      handleLanguageChange(data.data.country_code);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsLoading(true);
    if (!user) {
      getLanguageBasedOnLocation();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { isLoading };
};
